"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
var react_2 = require("@headlessui/react");
function Notifications(_a) {
    var user = _a.user;
    var notifications = {
        data: []
    };
    if (!user.id) {
        return react_1.default.createElement("div", { className: 'storybook-users-notifications' },
            react_1.default.createElement(storybook_1.Users.NotificationsBadge, { notifications: notifications, onClick: function () { return openMenu(); } }));
    }
    var _b = ra_fetch_1.useApi('backend')
        .index('notifications', { 'user_id': user.id, page: 1, paginate: 10 }), notificationsIndex = _b[0], setNotificationsIndex = _b[1];
    var _c = react_1.useState(false), open = _c[0], setOpen = _c[1];
    function openMenu() {
        if (!user.id) {
            window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_SITE_URL + "/login";
        }
        else {
            setOpen(!open);
        }
    }
    if (notificationsIndex.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: 'storybook-users-notifications' },
        react_1.default.createElement(storybook_1.Users.NotificationsBadge, { notifications: notificationsIndex, onClick: function () { return openMenu(); } }),
        react_1.default.createElement(react_2.Transition.Root, { show: open, as: react_1.Fragment },
            react_1.default.createElement(react_2.Dialog, { as: "div", className: "storybook-users-notifications-dialog", onClose: setOpen },
                react_1.default.createElement("div", { className: "absolute inset-0 overflow-hidden" },
                    react_1.default.createElement(react_2.Dialog.Overlay, { className: "absolute inset-0" }),
                    react_1.default.createElement("div", { className: "fixed inset-y-0 right-0 max-w-full flex" },
                        react_1.default.createElement(react_2.Transition.Child, { as: react_1.Fragment, enter: "transform transition ease-in-out duration-500 sm:duration-700", enterFrom: "translate-x-full", enterTo: "translate-x-0", leave: "transform transition ease-in-out duration-500 sm:duration-700", leaveFrom: "translate-x-0", leaveTo: "translate-x-full" },
                            react_1.default.createElement("div", { className: "w-screen max-w-md" },
                                react_1.default.createElement("div", { className: "h-full flex flex-col bg-white shadow-xl" },
                                    react_1.default.createElement(storybook_1.Users.NotificationsHead, { setOpen: setOpen }),
                                    react_1.default.createElement("div", { className: "relative flex-1 px-4 pt-4 sm:px-6 overflow-y-scroll" },
                                        react_1.default.createElement(storybook_1.Users.NotificationsList, { open: open, setOpen: setOpen, notifications: notificationsIndex, setNotifications: setNotificationsIndex, user: user }))))))))));
}
exports.default = Notifications;
